import analytics from "../services/analytics";


export const adClickMixin = {
    methods: {
        trackAdLink(ad: AdPlacement){
            analytics.logAdClick(ad);
        }
    }
}